export const EVENT_TYPE = {
    SATISFACTION_VALUE: 'satisfactionReview',
    SHOULD_SEND_EMAIL: 'sendEmail',
    SHOULD_SEND_HR: 'sendHR',
    RATE_EXPERIENCE: 'rateExperience',
    SHOULD_START_NEW_CONVERSATION: 'startNewConversation',
    ASK_NEW_QUESTION: 'askNewQuestion',
}

export const COMPONENT_NAME = {
    HELPFUL_INFORMATION: 'helpful-information',
    SEND_EMAIL: 'send-email',
    SEND_HR: 'send-hr',
    NEW_CONVERSATION: 'new-conversation',
    ANSWER: 'answer',
    LOADER: 'loader',
    STAR_RATING: 'star-rating',
    PREDEFINED_BUTTONS: 'predefined-button',
}

export const DONNA_MESSAGE = {
    INTRODUCTORY_TEXT: (personality:string) => `Hello, <p> I'm ${personality}, your HR Policy Assistant. Ask me anything about Tek Experts' HR policies, from benefits to employment guidelines. I'm here to help.</p>  Please note: For anything confidential or personalized, avoid sharing sensitive personal information in this chat. Feel free to reach out directly to our HR team for personalized assistance. <p>How can I assist you today?</p>`,
    ANSWER_NOT_POSSIBLE_TEXT: "Thank you for your inquiry. I'm here to assist with questions related to [Company Name]'s HR policies. I couldn't locate the information in the policies' database. It's possible that the information might not be covered or is currently unavailable. For accurate and up-to-date details, please consider reaching out to the HR department directly.",
    WAS_INFORMATION_HELPFUL: 'Was the information provided helpful?',
    GREAT_TO_HEAR: "That's great to hear that you found the information helpful! If you'd like, I can send you a copy of this information to your email for your records.",
    APOLOGIZE: "I apologize if the information provided wasn't helpful. I'm here to assist, and I want to ensure you get the answers you need. Would you like to send your question to the HR department, who will contact you back?",
    INFORMATION_SENT_TO_EMAIL: "The information has been sent to your email. If you have any more questions or need further assistance, feel free to ask.",
    I_COMPLETELY_UNDERSTAND: "I completely understand. If you have more questions in the future, don't hesitate to reach out.",
    RATE_EXPERIENCE: "We greatly appreciate your feedback! How would you rate your experience with AskHR? After providing your rating, you will have the opportunity to ask a new question. Your input helps us improve our services!",
    THANK_YOU_FOR_SHARING: "Thank you for your feedback! We appreciate it. <br> Please feel free to ask any additional questions you may have",
    THANK_YOU_FOR_USING: "Thank you for using our HR Policy Assistant. If you have any more questions in the future, don't hesitate to reach out. Have a great day!",
    QUESTION_SENT_TO_HR: "Your question was sent to the HR Department. Expect a person to contact you soon.",
    FEEL_FREE_TO_ASK: "Of course! Feel free to ask another HR policy-related question, and I'll provide you with the information you need.",
    WOULD_YOU_LIKE_TO_SEND_TO_HR: "Would you like me to forward your question to the HR department, who will contact you back?",
}

export const BOT_PERSONALITIES = [
    { id: '55c3e3f6-494e-42ef-973a-2b66a00281bd', name: 'AskHR'},
]

export const BOT_PREDEFINED_QUESTIONS = [
    { message: 'How many vacation days do I get per year?', active: true },
    { message: 'Can you explain the process for requesting time off?', active: true },
    { message: 'What happens if I have started work late?', active: true }
]

export const DONNA_PREDEFINED_BTNS = {
    HELPFUL: "Yes, it was",
    NOT_HELPFUL: "No, it wasn't",
    NEW_CONVERSATION: "Start a new conversation",
    SEND_COPY: "Yes, send copy of the answer to my e-mail",
    NOT_SEND_COPY: "Don't send me an e-mail",
    SEND_TO_HR: "Email HR with this Question",
    ASK_NEW: "Ask a new Question",
    NOT_SEND_TO_HR: "Don't send to HR",
    RATE: "Rate",
    RATE_AND_ASK_NEW: "Rate and ask a new question",
    CANCEL: "Cancel",
}